import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { BucketFindInterface } from '@zaoblako/shared/modules/storage/dtos/bucket/bucket-find.dto';
import type { BucketFindManyQueryInterface } from '@zaoblako/shared/modules/storage/dtos/bucket/bucket-find-many-query.dto';
import type { BucketPageInterface } from '@zaoblako/shared/modules/storage/dtos/bucket/bucket-page.dto';

import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BucketService extends BaseService {
  protected baseUrl = '/basis/storage/bucket';

  public findDefault(): Observable<BucketFindInterface> {
    return this.http.get<BucketFindInterface>(`${this.baseUrl}/default`);
  }

  public findMany(query?: BucketFindManyQueryInterface): Observable<BucketPageInterface> {
    return this.http.get<BucketPageInterface>(this.baseUrl, {
      params: query ? this.objectToHttpParams(query) : {}
    });
  }
}
